import { render, staticRenderFns } from "./templateAge.vue?vue&type=template&id=4d957b42&scoped=true"
import script from "./templateAge.vue?vue&type=script&lang=js"
export * from "./templateAge.vue?vue&type=script&lang=js"
import style0 from "./templateAge.vue?vue&type=style&index=0&id=4d957b42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d957b42",
  null
  
)

export default component.exports